## Element Yoga Methode

Die Frage, wie ich Yoga praktizieren kann, sodass es sich für mich richtig gut anfühlt, hat mich zum [Element Yoga Institut](https://elementyoga.de/) geführt. Dort durfte ich eine moderne, undogmatische und präzise Methode erlernen. Die von Alexander Kröker entwickelten Element Yoga Methode verbindet klassisches Hatha-Yoga mit den fünf Elementen des Ayurveda sowie moderner Bewegungslehre. Während meiner Aus- und Weiterbildungen habe ich gelernt, wie Haltungen und Bewegungen so praktiziert werden können, dass sie nicht nur individuell anpassbar sind, sondern auch, wie wir sie ausführen können, um langfristig gesund und verletzungsfrei zu üben.

Im Zentrum der Element Yoga Methode stehen die fünf Elemente – Erde, Wasser, Feuer, Luft und Raum. Jedem Element werden verschiedene Qualitäten, Körperbereiche und Yogahaltungen zugeordnet, die in einer Element Yoga Stunde meist mit einem inspirierenden Stundenthema vermittelt werden.


<br>

#### Aus- und Fortbildungen:

|          |                                  |
|--------------|-------------------------------------|
| 2017-18      | Grundausbildung Element Yoga (200h) |
| 2023         | Yin Yoga (100h)                     |
| 2023-24      | Advanced Alignment (100h)           |
| 2024         | Prä- und Postnatal Yoga (50h)       |
| 2024-25      | Personal Yoga (100h)                |
